/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


/**
 * Cart Locker should be used for holding certain actions when cart is locked, eg. when ordering approved quotes,
 * user shouldn't be able to add more products to quote etc
 */
define('modules/Cart/CartLocker',[
    'jquery',
    'lodash',
    'global/all',
    './CartManager'
], function ($, _, Roc) {
    'use strict';

    var lockFlagCookieName = 'is_cart_locked';

    function isCartUnlocked() {
        var deferred = $.Deferred();
        var isCartLocked = Roc.Core.readCookie(lockFlagCookieName) === 'true';
        if (isCartLocked) {
            Roc.UI.confirm({
                "title": 'Locked Cart',
                "message":
                    'Your cart is locked. Would you like to replace all items currently in your cart with item(s) that you are adding?',
                "buttons": {
                    "Continue": {
                        "class": 'btn btnAction confirm unlockCartButton',
                        "autoClose": false,
                        "action": function () {
                            Roc.Core.lockButton('.unlockCartButton');
                            removeCurrentCart()
                                .then(
                                    function () {
                                        deferred.resolve();
                                        $('.closeCartLockerModal').trigger('click');
                                    },
                                    function () {
                                        deferred.reject();
                                    });
                        }
                    },
                    "Cancel": {
                        "class": 'btn closeCartLockerModal',
                        "action": function () {
                            deferred.reject();
                        }
                    }
                }
            });
        } else {
            deferred.resolve();
        }
        return deferred;
    }

    function setLockFlag() {
        Roc.Core.createCookie(lockFlagCookieName, true);
    }

    function clearLockFlag() {
        Roc.Core.eraseCookie(lockFlagCookieName);
    }

    function removeCurrentCart() {
        return $.ajax({
            url: '/ajax/ClearCurrentCart',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json'
        });
    }

    var CartLocker = {
        isCartUnlocked: isCartUnlocked,
        setLockFlag: setLockFlag,
        clearLockFlag: clearLockFlag
    };

    Roc.Logger.debug('CartLocker.js Loaded:', CartLocker);

    return CartLocker;
});

